/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { Loader } from 'quantux-ui';
import { BASE_URL } from '../../utils';
import CropperContainer from '../revenue-cycle-management/cropper-container';
import CaseDoc from '../case-doc';
import { FLAG_VALUE } from '../../utils';

const AnesthesiaForms = (props) => {
  const [pdfContainerHeight, setPdfContainerHeight] = useState(window.innerHeight - 162); // - 162
  const [imageData, setImageData] = useState({ images: [], croppedImages: [], activeIndex: 0, isReScan: false });
  const [isPDF, setIsPDF] = useState(false);
  const [pdfLink, setPdfLink] = useState(null);
  // ---
  const [docs, setDocs] = useState([]);
  const [isNone, setIsNone] = useState(false);

  const { caseData, isLoadingData } = props;

  const cropperRef = useRef();

  const handleWindowResize = () => {
    setPdfContainerHeight(window.innerHeight - 275);
  };

  const getFormData = (form) => {
    const myHeaders = new Headers();
    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);
    // --------------------------- Preparing case data ---------------------------
    const formData = new FormData();

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formData,
      redirect: 'follow'
    };

    switch (form) {
      case 'faceSheet':
        formData.append('formKey', caseData.faceSheetKey);
        break;
      case 'consentForm':
        formData.append('formKey', caseData.consentFormKey);
        break;
      case 'prePostOpForm':
        formData.append('formKey', caseData.prePostOpFormKey);
        break;
      case 'intraOpForm':
        formData.append('formKey', caseData.intraOpFormKey);
        break;
      default:
        console.log('Form name not correct!');
    }

    fetch(`${BASE_URL}/cases/getFormSignedUrl`, requestOptions)
      .then(response => response.text())
      .then(result => {
        const res = JSON.parse(result);
        if (res.success) {
          setPdfLink(res.url);
        }
      });
  };

  // ------------------------------------ Effects ------------------------------------
  // ------ Window resize
  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    handleWindowResize();
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  useEffect(() => {
    // console.log(`============ props.subTab = ${props.subTab} ============`);
    switch (props.subTab) {
      case 'faceSheet':
        // setImageData(caseData.faceSheetData || { images: [], croppedImages: [], activeIndex: 0, isReScan: false });
        setDocs(caseData.faceSheetDocs);
        setIsNone(caseData.isNoneFaceSheet);
        break;
      case 'labs':
        setDocs(caseData.labsDocs);
        setIsNone(caseData.isNoneLabDocs);
        break;
      case 'ekg':
        setDocs(caseData.ekgDocs);
        setIsNone(caseData.isNoneEkgDocs);
        break;
      case 'imaging':
        setDocs(caseData.imagingDocs);
        setIsNone(caseData.isNoneImagingDocs);
        break;
      case 'consults':
        setDocs(caseData.consultsDocs);
        setIsNone(caseData.isNoneConsults);
        break;
      case 'consent_surgery':
        setDocs(caseData.consentSurgFormDocs);
        setIsNone(caseData.isNoneConsentSurgFormDocs);
        break;
      case 'consent_anethesia':
        setDocs(caseData.consentFormDocs);
        setIsNone(caseData.isNoneConsentFormDocs);
        break;
      case 'nursing':
        setDocs(caseData.nursingDocs);
        setIsNone(caseData.isNoneNursingDocs);
        break;
      case 'surgeon':
        setDocs(caseData.surgeonDocs);
        setIsNone(caseData.isNoneSurgeonDocs);
        break;
      case 'anesthesia_preOp':
        setDocs(caseData.preOpFormDocs);
        setIsNone(caseData.isNonePreOpFormDocs);
        break;
      case 'anesthesia_intraOp':
        setDocs(caseData.intraOpFormDocs);
        setIsNone(caseData.isNoneIntraOpFormDocs);
        break;
      case 'anesthesia_postOp':
        setDocs(caseData.postOpFormDocs);
        setIsNone(caseData.isNonePostOpFormDocs);
        break;
      case 'orders_preOp':
        setDocs(caseData.ordersPreOpDocs);
        setIsNone(caseData.isNoneOrdersPreOpDocs);
        break;
      case 'orders_intraOp':
        setDocs(caseData.ordersIntraOpDocs);
        setIsNone(caseData.isNoneOrdersIntraOpDocs);
        break;
      case 'orders_postOp':
        setDocs(caseData.ordresPostOpDocs);
        setIsNone(caseData.isNoneOrdersPostOpDocs);
        break;
      case 'discharge':
        setDocs(caseData.dischargeDocs);
        setIsNone(caseData.isNoneDischargeDocs);
        break;
      default:
        setDocs(caseData.faceSheetDocs);
        setIsNone(caseData.isNoneFaceSheet);
    }
  }, [props.subTab, props.caseData]);

  // ------------------------------------ Effects ------------------------------------

  const handleOnChangeIsNoneFaceSheet = () => { };

  const handleOnFaceSheetDocsUploaded = () => { };

  const handleOnDeleteFaceSheetPage = () => { };

  const handleOnDeleteFaceSheetDocument = () => { };


  let activeComp = null;
  if (!isPDF) {
    activeComp = (
      <CaseDoc
        formType={props.formType}
        caseDocs={docs}
        isNone={isNone}
        showFlag={false}
        flagType={FLAG_VALUE.critical}
        onChangeIsNone={props.onChangeIsNone}
        onCaseDocUploaded={props.onCaseDocUploaded}
        onDeletePage={props.onDeletePage}
        onDeleteDocument={props.onDeleteDocument}
      />
    );
  } else {
    activeComp = (
      // <a href={pdfLink}>
      //   Open PDF
      // </a>
      <iframe
        src={pdfLink}
        height="1020"
        width="1000"
      />
    );
  }

  return (
    <div style={{ height: '100%', width: '100%' }}>
      {isLoadingData
        ? <Loader iconType="cog" iconSize="5x" text="Loading Anesthesia Forms" />
        : activeComp
      }
    </div>
  );
};

export default AnesthesiaForms;
